import sharedEn from 'shared/src/_base/translations/en'
import intEn from 'translations/en'
import intFrFrance from 'translations/fr_france'
import intFrCanada from 'translations/fr_canda'
import intPt from 'translations/pt'
import intSP from 'translations/sp'
import intIt from 'translations/it'
import intDe from 'translations/de'
const initialState = {
  en_us: {
    ...sharedEn,
    ...intEn
  },
  fr_ca: {
    ...intFrCanada
  },
  fr_fr: {
    ...intFrFrance
  },
  pt_br: {
    ...intPt
  },
  it_it: {
    ...intIt
  },
  es_es: {
    ...intSP
  },
  de_de: {
    ...intDe
  },
}

const translationsReducer = (state = initialState) => state

export default translationsReducer
